import {createReducer} from '@reduxjs/toolkit';
import {
    getLimitsSuccess,
    saveLimitsSuccess,
} from 'src/openapi/admin/apis/LimitControllerApi';
import {PricingModel} from 'src/openapi/admin/models/PricingModel';

import type {LimitList} from 'src/openapi/admin/models/LimitList';

type LimitsState = Record<string, LimitList | null>;

export type State = Record<PricingModel, LimitsState>;

const initialState: State = {
    [PricingModel.SUBSCRIPTION]: {},
    [PricingModel.PAY_PER_CALL]: {},
    [PricingModel.INTEGRATION]: {},
};

export const data = createReducer(initialState, builder => builder
    .addCase(getLimitsSuccess, (state, action) => {
        const {pricingModel, accountId} = action.payload.meta;
        return {
            ...state,
            [pricingModel]: {
                ...state[pricingModel],
                [accountId]: action.payload.data,
            },
        };
    })
    .addCase(saveLimitsSuccess, (state, action) => {
        const {pricingModel, accountId, apiLimit} = action.payload.meta;

        return {
            ...state,
            [pricingModel]: {
                ...state[pricingModel],
                [accountId]: {
                    limits: apiLimit,
                    changesInfo: action.payload.data,
                },
            },
        };
    }),
);
